<div class="confirm-address-popup">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <h4>Please confirm your address</h4>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 nopad">
      <ol class="col-centered">
        
        <div [ngClass] = "[index === 'entered'?'highlightGray':'']" >
          <hr />
        <li class = "radio custom-radio">
            <input type="radio" name="radio" id="entered" (click)="setAddress('entered')">
            <label for="entered"><span class="font-italic">Address you’ve entered -</span><br><span [innerHtml]='enteredAddress'></span></label>
        </li>
        <hr class="separator" />
      </div >
      <div class="bottomdiv" [ngClass] = "[index === 'actual'?'highlightGray':'']" >
        <li class ="radio custom-radio">
            <input type="radio" name="radio" id="actual" (click)="setAddress('actual')">
            <label for="actual"><span class="font-italic">Address we’ve found -</span><br><span [innerHtml]='actualAddress'></span></label>
        </li>
        <hr />
      </div>
    </ol>
     </div>
  </div>
  <div class="row mg-top-10">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mg-top-24">
      <button type="submit" [disabled]= "disabled" (click)='confirmAddress()' class="btn wb-btn-default center-block">Confirm Address</button>
    </div>    
  </div>  
</div>